import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AuthShell, field, goldBtn } from "@/pages/Login";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Enter a valid email");
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim().toLowerCase(), origin_url: window.location.origin });
      setSent(true);
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell tag="Members" title="Reset password" footer={<>Remembered it? <Link to="/login" className="text-[#D4AF37]">Sign in</Link></>}>
      {sent ? (
        <div className="border border-[#D4AF37]/40 bg-[#D4AF37]/5 p-6" data-testid="forgot-sent">
          <p className="text-white">If an account exists for <b>{email}</b>, a reset link is on its way. Check your inbox (and spam).</p>
        </div>
      ) : (
        <>
          <p className="text-white/50 text-sm">Enter your email and we'll send you a link to set a new password.</p>
          <input data-testid="forgot-email" type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} className={field} />
          <button data-testid="forgot-submit" onClick={submit} disabled={busy || !email} className={goldBtn}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
          </button>
        </>
      )}
    </AuthShell>
  );
}
